<template>
  <div class="field">
    <v-form
      v-model="valid"
      ref="form"
    >
      <v-text-field
        v-model="email"
        :rules="emailRules"
        label="E-mail"
        required
        v-on:keydown.enter.prevent="submit"
      ></v-text-field>
    </v-form>
    <v-btn v-on:click="submit" :loading="loading">
      <v-icon v-if="!loading && !success && !error"> mdi-email </v-icon>
      <v-icon v-if="!loading && success"> mdi-check </v-icon>
      <v-icon v-if="error"> mdi-cancel </v-icon>
    </v-btn>
  </div>
</template>

<script>
export default {
  data () {
    return {
      email: '',
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid'
      ],
      valid: true,
      loading: false,
      success: false,
      error: false
    }
  },
  methods: {
    submit () {
      if (this.$refs.form.validate()) {
        this.loading = true
        this.$axios
          .post('/welcome', { email: this.email })
          .then((response) => {
            console.log(response)
            if (response.data) {
              this.loading = false
              this.success = true
              this.error = false
            } else {
              this.loading = false
              this.success = false
              this.error = true
            }
          })
          .catch((error) => {
            // handle error
            console.log(error)
            this.loading = false
            this.success = false
            this.error = true
            return error
          })
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
